import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadAIUXSprintPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'AI UX スプリント 資料 ホワイトペーパー'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/download/ai-ux-sprint/done/'}
          title="ご入力いただきありがとうございます | AI-UXスプリントサービス紹介資料 | 資料ダウンロード | Aitria（アイトリア）"
          description="AI×UX専門家が曖昧な要件を最短2週間でプロトタイプ化。議論を加速し、本質的な体験設計を可能にするアプローチをご紹介します。AIによる「実務で使えないUI」の罠を回避したいなら 、最短2週間で停滞を「議論できる体験」へ変える本手法をご活用ください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
